<template>
  <button class="button"
          :type="type"
          :disabled="loading"
          @click.stop="emitClick">
    <loading v-if="loading"
             class="button-loading"
             primary />

    <i v-if="icon && !loading"
       :class="`mdi mdi-${icon}`"></i>

    <p class="button-label"
       :style="notAllowedStyle">{{ label }}</p>
  </button>
</template>

<script>
import Loading from "@/components/generic/Loading.vue";

export default {
  components: {
    Loading,
  },

  data() {
    return {};
  },

  props: {
    icon: {
      type: String,
    },
    label: {
      type: String,
    },
    type: {
      type: String,
      default: "button",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    allowed: {
      type: Boolean,
      default: true,
    }
  },

  created() {},

  computed: {
    notAllowedStyle() {
      return this.allowed ? "" : {"cursor": "not-allowed"}
    }
  },

  watch: {},

  methods: {
    emitClick() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.button {
  padding: 10px 30px;
  box-shadow: 0px 3px 6px #00000024;
  font-weight: 600;
  border-radius: $button-radius;
  display: flex;
  align-items: center;
  justify-content: center;
 

  .button-label {
    font-size: 15px;
    margin: 0;
  }

  i {
    margin-right: 5px;
  }

  .button-loading {
    margin-right: 10px;
  }

  &[outline] {
    border: 1px solid #d6d6d6;
  }

  &[primary] {
    color: #ffffff;
    background-color: $primary;

    .button-loading {
      border-top-color: $primary;
    }
  }

  &[negative] {
    color: #ffffff;
    background-color: #ff4051;

    .button-loading {
      border-top-color:  #ff4051;
    }
  }

  &[flat] {
    box-shadow: none;
    border: 1px solid #d6d6d6;
  }

  &[small] {
    padding: 5px 16px;

    .button-label {
      font-size: 12px;
    }
  }

  &[underline] {
    border: none;
    border-bottom: 1px solid #d6d6d6;
    border-radius: 0;
    background-color: transparent;
    color: #707070;
    padding: 0;

    &[primary] {
      color: $primary;
      border-color: $primary;
    }
  }

  &[bordered] {
    border: 1px solid #d6d6d6;
  }

  &:hover {
    transform: translateY(-1px);
  }

  &:active {
    box-shadow: none;
    transform: translateY(1px);
  }

  &:disabled {
    box-shadow: none;
    transform: translateY(0);
    background: #f1f1f1;
    border-color: #d9d9d9;
    cursor: not-allowed;

    &[primary] {
      background-color: rgba($primary, 0.2);
      border-color: $primary;
    }
  }
}
</style>
